import React, { useState } from "react";
import CharacterListItem from './CharacterListItem'



const CharacterList = ({
    characters, setCharacters, setSavedCharacters,
    setSelectedCharacter,
    setSelectedView, setIsEditing,
    createCharacterAction}) => {

        return (
            <div>
                        <div className="character-box">
                            <div className="App--general-action-header" >
                                CHARACTERS
                            </div>
                            <div className="App--character-list-box-inner">
                            {characters.map((characterItem) => {
                                return (
                                    <CharacterListItem
                                        characterItem={characterItem}
                                        setCharacters={setCharacters}
                                        setSavedCharacters={setSavedCharacters}
                                        setSelectedCharacter={setSelectedCharacter}
                                        characters={characters}
                                        key={characterItem.id}
                                        setSelectedView={setSelectedView}
                                        setIsEditing={setIsEditing}
                                        
                                    />
                                );
                            })}
                            <CharacterListItem
                                characterItem={null}
                                key={0}
                                createCharacterAction={createCharacterAction}
                            />
                            </div>
                        </div>
             </div>
        );
    
}

export default CharacterList;